import { Menu } from 'antd';

export const LCMenuItem = Menu.Item;
